import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Changes the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#taxcalculationmode"
        }}>{`TaxCalculationMode`}</a>{` of a cart. When changing the tax calculation mode, the taxes are recalculated.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"changeTaxCalculationMode"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`taxCalculationMode`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#taxcalculationmode"
          }}>{`TaxCalculationMode`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      